import React from "react";
import { Image } from "semantic-ui-react";
import { getCustomer, getLogo } from "@services/auth";

import EuropagIcon from "@src/assets/images/empresas/favicon/europag.png";
import MovingpayIcon from "@src/assets/images/empresas/favicon/movingpay.png";
import CloudwalkIcon from "@src/assets/images/empresas/favicon/cloudwalk.png";
import PaygoIcon from "@src/assets/images/empresas/favicon/paygo.png";
import WowSolucoesIcon from "@src/assets/images/empresas/favicon/wowsolucoes.png";
import MultpagIcon from "@src/assets/images/empresas/favicon/multpag.png";
import CartosIcon from "@src/assets/images/empresas/favicon/cartos.png";
import FixpayIcon from "@src/assets/images/empresas/favicon/fixpay.png";
import PagolivreIcon from "@src/assets/images/empresas/favicon/pagolivre.png";
import ServpayIcon from "@src/assets/images/empresas/favicon/servpay.png";
import CasaDoCreditoIcon from "@src/assets/images/empresas/favicon/casadocredito.png";
import EdenredIcon from "@src/assets/images/empresas/favicon/edenred.png";

import DefaultLogo from "@src/assets/images/empresas/default.png";

let aux;

export const LogoCompany = (props) => {
  let logo
  logo = getLogo()

  return (
    <Image
      loading="lazy"
      verticalAlign="middle"
      floated={props.alinhamento ? props.alinhamento : "left"}
      src={logo !== undefined && logo !== '' ? 'https://movingpay-logos.s3.sa-east-1.amazonaws.com/' + logo : MovingpayIcon}
      className={"img-fluid" + props.className ? props.className : ""}
    />
  );
};

export const LogoText = (props) => {

  let emp = getCustomer() ? getCustomer() : '0_0';
  let data = emp.split('_')
  let empresaId = parseInt(data[0])

  switch (empresaId) {
    case 1:
      aux = "Europag";

      break;

    case 2:
      aux = "Movingpay";

      break;

    case 6:
      aux = "CloudWalk";

      break;

    case 7:
      aux = "PayGo • C6";

      break;

    case 8:
      aux = "Wow Solution";

      break;

    case 10:
    case 17:
      aux = "Multpag";

      break;

    case 11:
      aux = "Cartos Fintech";

      break;

    case 12:
      aux = "FIX PAY";

      break;

    case 13:
      aux = "Pagolivre";

      break;

    case 14:
      aux = "SERVPAY";

      break;

    case 15:
      aux = "Casa do Crédito";

      break;

    case 16:
      aux = "Edenred";

      break;

    default:
      aux = "";
      break;
  }

  return aux.toUpperCase();
};

export const LogoCompanyMini = (props) => {

  let emp = getCustomer() ? getCustomer() : '0_0';
  let data = emp.split('_')
  let empresaId = parseInt(data[0])

  switch (empresaId) {
    case 1:
      aux = EuropagIcon;
      break;

    case 2:
      aux = MovingpayIcon;
      break;

    case 6:
      aux = CloudwalkIcon;
      break;

    case 7:
      aux = PaygoIcon;
      break;

    case 8:
      aux = WowSolucoesIcon;
      break;

    case 10:
    case 17:
      aux = MultpagIcon;
      break;

    case 11:
      aux = CartosIcon;
      break;

    case 12:
      aux = FixpayIcon;
      break;

    case 13:
      aux = PagolivreIcon;
      break;

    case 14:
      aux = ServpayIcon;
      break;

    case 15:
      aux = CasaDoCreditoIcon;
      break;

    case 16:
      aux = EdenredIcon;
      break;

    default:
      aux = DefaultLogo;
      break;
  }

  return (
    <Image
      loading="lazy"
      verticalAlign="middle"
      floated={props.alinhamento ? props.alinhamento : "left"}
      src={aux}
      className={"img-fluid" + props.className ? props.className : ""}
    />
  );
};

export const changeIconFav = () => {

  let emp = getCustomer() ? getCustomer() : '0_0';
  let data = emp.split('_')
  let empresaId = parseInt(data[0])

  switch (empresaId) {
    case 1:
      aux = EuropagIcon;
      break;

    case 2:
      aux = MovingpayIcon;
      break;

    case 6:
      aux = CloudwalkIcon;
      break;

    case 7:
      aux = PaygoIcon;
      break;

    case 8:
      aux = WowSolucoesIcon;
      break;

    case 10:
    case 17:
      aux = MultpagIcon;
      break;

    case 11:
      aux = CartosIcon;
      break;

    case 12:
      aux = FixpayIcon;
      break;

    case 13:
      aux = PagolivreIcon;
      break;

    case 14:
      aux = ServpayIcon;
      break;

    case 15:
      aux = CasaDoCreditoIcon;
      break;

    case 16:
      aux = EdenredIcon;
      break;

    default:
      aux = DefaultLogo;
      break;
  }

  return aux;
};
